module.exports = __webpack_public_path__ + "static/media/no-website-img.b8b16bd5.svg";